'use client'

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("App Error:", error.message, error.stack);
  }, [error]);

  return (
    <div style={{ padding: 32, fontFamily: "monospace" }}>
      <h2>Ошибка приложения</h2>
      <pre style={{ background: "#fee", padding: 16, borderRadius: 8, overflow: "auto" }}>
        <b>{error.name}: {error.message || "(no message)"}</b>
        {"\n\n"}
        {error.stack}
      </pre>
      <button onClick={reset} style={{ marginTop: 16, padding: "8px 16px" }}>
        Попробовать снова
      </button>
    </div>
  );
}
